export enum MaskMode {
    NONE = 'NONE',
    ALPHA = 'ALPHA',
    ALPHA_INVERTED = 'ALPHA_INVERTED',
}
